import {
    ESTIMATE_DETAIL_INIT,
    EstimateDetail,
    EstimatePattern,
    SetStateEstimate,
    PATTERN_NAME_LEN,
    DeviceInfoRow,
    EstimateInquiry,
    DEVICE_MEMO_MAX_LEN,
} from '../../types/common/EstimateInquiryType';
import { TEMP_TYPE } from '../../types/common/CommonType';
import { ErrorMessages } from '../../types/common/Messages';

import { AppDispatch } from '../../store/store';
import {
    setState as setEstimateInquiryStore,
    addEstimatePattern as addEstimatePatternStore,
    delEstimatePattern as delEstimatePatternStore,
} from '../../slice/EstimateInquirySlice';

// 見積条件のstate更新
const setStateEstimatePattern = (
    dispatch: AppDispatch,
    estimateInquiry: EstimateInquiry,
    changedEstimatePatternRowValue: EstimatePattern
) => {
    const changedEstimatePatternList = estimateInquiry.estimatePatternList.map((pattern) => {
        if (pattern.estimatePatternRowNumber === changedEstimatePatternRowValue.estimatePatternRowNumber) {
            return {
                ...pattern,
                estimatePatternName: changedEstimatePatternRowValue.estimatePatternName,
            };
        } else {
            return pattern;
        }
    });
    const changedEstimateInquiry = {
        ...estimateInquiry,
        estimatePatternList: changedEstimatePatternList,
    };
    dispatch(setEstimateInquiryStore(changedEstimateInquiry));
};

// 見積詳細のstate更新
const setStateEstimateDetail = (
    dispatch: AppDispatch,
    estimateInquiry: EstimateInquiry,
    changedEstimateDetailData: EstimateDetail,
    changedEstimatePatternRowNumber: number
) => {
    const changedEstimatePatternList = estimateInquiry.estimatePatternList.map((pattern) => {
        if (changedEstimatePatternRowNumber === pattern.estimatePatternRowNumber) {
            const changedEstimateList = pattern.estimateList.map((estimate) => {
                if (
                    estimate.deviceRowNumber === changedEstimateDetailData.deviceRowNumber &&
                    estimate.inputRowNumber === changedEstimateDetailData.inputRowNumber
                ) {
                    return {
                        ...estimate,
                        startYear: changedEstimateDetailData.startYear,
                        startMonth: changedEstimateDetailData.startMonth,
                        endYear: changedEstimateDetailData.endYear,
                        endMonth: changedEstimateDetailData.endMonth,
                        maintenanceLevelCode: changedEstimateDetailData.maintenanceLevelCode,
                        checkFlag: changedEstimateDetailData.checkFlag,
                    };
                }
                return estimate;
            });
            // 全選択フラグを更新
            const checkAllFlag = changedEstimateList.find((it) => !it.checkFlag) === undefined ? true : false;
            return {
                ...pattern,
                estimateList: changedEstimateList,
                checkAllFlag: checkAllFlag,
            };
        }
        return pattern;
    });
    const changedEstimateInquiry = {
        ...estimateInquiry,
        estimatePatternList: changedEstimatePatternList,
    };
    dispatch(setEstimateInquiryStore(changedEstimateInquiry));
};

// 見積詳細のチェック状態一括更新
const setStateEstimateDetailCheckFlagAll = (
    dispatch: AppDispatch,
    estimateInquiry: EstimateInquiry,
    changedCheckFlag: boolean,
    changedEstimatePatternRowNumber: number
) => {
    const changedEstimatePatternList = estimateInquiry.estimatePatternList.map((pattern) => {
        if (pattern.estimatePatternRowNumber === changedEstimatePatternRowNumber) {
            return {
                ...pattern,
                checkAllFlag: changedCheckFlag,
                estimateList: pattern.estimateList.map((estimate) => {
                    return {
                        ...estimate,
                        checkFlag: changedCheckFlag,
                    };
                }),
            };
        }
        return pattern;
    });
    const changedEstimateInquiry = {
        ...estimateInquiry,
        estimatePatternList: changedEstimatePatternList,
    };
    dispatch(setEstimateInquiryStore(changedEstimateInquiry));
};

// 年月バリデーション
const yearMonthValidation = (estDetail: EstimateDetail) => {
    const validationResult: Array<string> = [];
    const startYYYYMM = Number(`${estDetail.startYear}${estDetail.startMonth?.padStart(2, '0')}`);
    const endYYYYMM = Number(`${estDetail.endYear}${estDetail.endMonth?.padStart(2, '0')}`);
    // VAL-02
    if (endYYYYMM < startYYYYMM) {
        validationResult.push(ErrorMessages.INQ_EST_VAL03);
    }

    // 当年
    const thisYear = new Date().getFullYear();
    // 当月
    const thisMonth = new Date().getMonth() + 1;
    // VAL-03
    if (Number(estDetail.startYear) <= thisYear && Number(estDetail.startMonth) <= thisMonth) {
        validationResult.push(ErrorMessages.INQ_EST_VAL04);
    }

    return validationResult;
};

// 見積り依頼のバリデーション
const validateEstimation = (estimateInquiry: EstimateInquiry, tempSaveFlag: boolean, tempType: string = '') => {
    const validationResult: Array<string> = [];
    const patternNameList: Array<string> = [];
    let estimateSelectedCount = 0;
    // DEVICE_VAL01 見積り機器が無い
    if (estimateInquiry.deviceList.length === 0) {
        validationResult.push(ErrorMessages.INQ_DEVICE_VAL01);
    }
    // DEVICE_VAL02 見積り機器備考の文字数
    estimateInquiry.deviceList.forEach((device) => {
        device.inputList.forEach((it) => {
            if (it.freeText !== undefined && it.freeText.length > DEVICE_MEMO_MAX_LEN) {
                // 機種名
                let deviceName = device.makerName ? `${device.makerName} ` : '';
                deviceName += device.modelName ? device.modelName : device.searchWord;
                validationResult.push(ErrorMessages.INQ_DEVICE_VAL02.replace('%1', deviceName));
            }
        });
    });
    estimateInquiry.estimatePatternList.forEach((estimatePattern, index) => {
        // 一時保存ではない、または見積り条件編集画面から遷移して一時保存
        if (!tempSaveFlag || tempType === TEMP_TYPE.ESTIMETE_TEMP) {
            // EST_VAL01 見積り条件の件数
            if (estimateInquiry.estimatePatternList.length === 0) {
                validationResult.push(ErrorMessages.INQ_EST_VAL01);
            }
        }
        // 一時保存ではない場合
        if(!tempSaveFlag) {
            // EST_VAL02 見積り条件の名称は入力必須
            if (estimatePattern.estimatePatternName === undefined || estimatePattern.estimatePatternName == '') {
                validationResult.push(ErrorMessages.INQ_EST_VAL02.replace('%1', (index + 1).toString()));
            }
        }
        // 一時保存ではない場合
        if (!tempSaveFlag) {
            estimatePattern.estimateList.forEach((estimate) => {
                // VAL03~04チェック
                const yearValidRestult = yearMonthValidation(estimate);
                if (yearValidRestult.length > 0) {
                    validationResult.push(...yearValidRestult);
                }
                // 選択される見積り詳細の件数を計上
                estimateSelectedCount += estimate.checkFlag ? 1 : 0;
            });
        }
        // EST_VAL05 見積り名称の文字数
        if (estimatePattern.estimatePatternName.length > PATTERN_NAME_LEN) {
            validationResult.push(ErrorMessages.INQ_EST_VAL05.replace('%1', (index + 1).toString()));
        }
        patternNameList.push(estimatePattern.estimatePatternName);
    });
    if (!tempSaveFlag) {
        // EST_VAL06 見積り名称が重複
        const uniquPatternNameList = new Set(patternNameList);
        if (uniquPatternNameList.size !== patternNameList.length) {
            validationResult.push(ErrorMessages.INQ_EST_VAL06);
        }
        // EST_VAL07 見積り詳細（選択）の件数
        if (estimateSelectedCount === 0) {
            validationResult.push(ErrorMessages.INQ_EST_VAL07);
        }
    }

    return validationResult;
};

// 見積詳細リストを作成
const createEstimateDetailListByDivce = (
    preEstimateList: Array<EstimateDetail>,
    deviceList: Array<DeviceInfoRow>
): Array<EstimateDetail> => {
    const estimateList: Array<EstimateDetail> = [];
    deviceList?.forEach((device) => {
        device.inputList?.forEach((input) => {
            // 同じ機器対象の判定、機器行No＋編集行No
            const preEstimate = preEstimateList.find(
                (it) => it.deviceRowNumber === input.deviceRowNumber && it.inputRowNumber === input.inputRowNumber
            );
            let estimateDetail: EstimateDetail;
            if (preEstimate) {
                // 上書き更新
                estimateDetail = preEstimate;
            } else {
                // 新規追加
                estimateDetail = {
                    ...ESTIMATE_DETAIL_INIT,
                    deviceRowNumber: input.deviceRowNumber ?? 1,
                    inputRowNumber: input.inputRowNumber ?? 1,
                    checkFlag: true,
                };
            }
            estimateList.push(estimateDetail);
        });
    });
    return estimateList;
};

// state更新用の関数を生成
const generateSetState = (dispatch: AppDispatch, estimateInquiry: EstimateInquiry) => {
    const setState: SetStateEstimate = {
        // 見積条件項目のstate更新
        setStateEstimatePattern: (changedEstimatePatternData: EstimatePattern) => {
            EditEstimateRowLogic.setStateEstimatePattern(dispatch, estimateInquiry, changedEstimatePatternData);
        },
        // 見積詳細項目のstate更新
        setStateEstimateDetail: (
            changedEstimateDetailData: EstimateDetail,
            changedEstimatePatternRowNumber: number
        ) => {
            EditEstimateRowLogic.setStateEstimateDetail(
                dispatch,
                estimateInquiry,
                changedEstimateDetailData,
                changedEstimatePatternRowNumber
            );
        },
        // 見積詳細のチェック状態一括更新
        setStateEstimateDetailCheckFlagAll: (changeCheckFlag: boolean, changedEstimatePatternRowNumber: number) => {
            EditEstimateRowLogic.setStateEstimateDetailCheckFlagAll(
                dispatch,
                estimateInquiry,
                changeCheckFlag,
                changedEstimatePatternRowNumber
            );
        },
        // 見積条件のstate削除
        deleteStateEstimatePattern: (delEstimatePatternRowNumber: number) => {
            //EditEstimateRowLogic.deleteStateEstimatePattern(dispatch, delEstimatePatternRowNumber);
            dispatch(delEstimatePatternStore(delEstimatePatternRowNumber));
        },
        // 見積条件のstate追加
        addStateEstimatePattern: () => {
            //EditEstimateRowLogic.addStateEstimatePattern(dispatch, estimateInquiry);
            // 見積機器詳細リストを作成
            const estimateList = EditEstimateRowLogic.createEstimateDetailListByDivce([], estimateInquiry.deviceList);
            dispatch(addEstimatePatternStore(estimateList));
        },
    };

    return setState;
};

export const EditEstimateRowLogic = {
    setStateEstimatePattern,
    setStateEstimateDetail,
    setStateEstimateDetailCheckFlagAll,
    validateEstimation,
    createEstimateDetailListByDivce,
    generateSetState,
};
